import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class VentaService {
  private url: string = "https://orca-app-3c9vq.ondigitalocean.app";
  constructor(private login:LoginService,private http:HttpClient) {
  }
  async listar() {

    this.url = "https://orca-app-3c9vq.ondigitalocean.app";
    return this.http.get<any[]>(`${this.url}/venta/` , {
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization' , this.login.getToken())
      .set('empresaId' , this.login.getEmpresa())
    });
  }
  async getventa(id){

    this.url = "https://orca-app-3c9vq.ondigitalocean.app";
    return this.http.get<any[]>(`${this.url}/venta/${id}` , {
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization' , this.login.getToken())
      .set('empresaId' , this.login.getEmpresa())
    });
  }
  mostrarPdf(payload){
    const config = {
      responseType:"arraybuffer",
      responseEncoding : "binary",
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization' , this.login.getToken())
      .set('empresaId' , this.login.getEmpresa())      
    }
    return this.http.post<any[]>(`${this.url}/cotizacion/ordenDespacho`,payload ,config );
    
  }
  insertar(prod){
    prod.fecha = new Date(prod.fecha);
    return this.http.post<any[]>(`${this.url}/venta/`,prod , {
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization' , this.login.getToken())
      .set('empresaId' , this.login.getEmpresa())
    });
  }
  actualizar(prod,id){
    return this.http.patch<any[]>(`${this.url}/venta/${id}`,prod , {
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization' , this.login.getToken())
      .set('empresaId' , this.login.getEmpresa())
    });
  }

  eliminar(prod,id){
      prod.estado = false;
      delete prod.__v;
      return this.http.patch<any[]>(`${this.url}/venta/${id}`,prod , {
        headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Authorization' , this.login.getToken())
        .set('empresaId' , this.login.getEmpresa())
      });
  }
    //var indice  = this.ventas.indexOf(prod);
    //this.ventas[indice] = prod;
    //console.log(this.ventas[indice]);


}
